import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import DisabledStarRating from "../CandidatesList/DisabledStarRating";

interface EvaluationDetailsModalProps {
  evaluation: {
    title: string;
    point: number;
    comment: string;
  };
  onClose: () => void;
}

const EvaluationDetailsModal: React.FC<EvaluationDetailsModalProps> = ({
  evaluation,
  onClose,
}) => {
  return (
    <Transition.Root show={true} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={onClose}
      >
        <div className="flex items-center justify-center min-h-screen p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="relative bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
              <h2 className="text-lg font-medium text-gray-900 mb-4">
                {evaluation.title}
              </h2>
              <div className="flex items-center justify-between mb-4">
                <p className="text-md">امتیاز:</p>
                <DisabledStarRating rating={evaluation.point} size={28} />
              </div>
              <div className="mb-4">
                <p className="text-md font-semibold">نظر:</p>
                <p className="text-gray-600 whitespace-pre-line">
                  {evaluation.comment || "بدون نظر"}
                </p>
              </div>
              <div className="flex justify-end mt-4">
                <button
                  className="text-white bg-primary hover:bg-blue-600 px-4 py-2 rounded"
                  onClick={onClose}
                >
                  بستن
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default EvaluationDetailsModal;
